import * as types from "./consts";

export const getCheckoutRequest = (payload?: object) => ({
    type: types.POST_CHECKOUT_REQUEST,
    payload,
});
